<template>
  <v-row class="pa-0">
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;line-height:2;">
      التكاليف المالية للخدمات
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
      <v-row class="pa-0" v-if="lead.program_name.slug == 'ausbildung'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          مميزات شركة ارامكو بما يتعلق بالدفعات المالية
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          تم تقسيم الدفعات المالية بما يتناسب مع الطلاب الجامعيين وذلك تسهيلا عليهم وايضا تم اختيار الوقت بين الدفعتين المالية بشكل مدروس من قبل الفريق الخاص بالدفعات المالية في شركة ارامكو لتناسب امكانيات الطلاب
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الأول
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          بعد توقيع هذا العقد يتم إصدار فاتورة من معهد اللغة بألمانيا بقيمة اجمالية تبلغ 3000 يورو والتي يتوجب على الطالب تحويلها مباشرة إلى معهد اللغة (German Akademie ) .
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثاني
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          يتوجب على الطالب تحويل مبلغ 2000 يورو الى حساب شركة أرامكو في المانيا عند وصول القبول الجامعي
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثالث
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          عند تحضير ملف السفارة و تزويد الطالب بجميع المستندات و الأوراق الرسمية وموافقة وزارة العمل وتسليمه كاملا للملتحق يترتب على الملتحق دفع مبلغ 1500 يورو بشكل مباشر على حساب شركة أرامكو في المانيا
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'students'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          مميزات شركة ارامكو بما يتعلق بالدفعات المالية
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          تم تقسيم الدفعات المالية بما يتناسب مع الطلاب الجامعيين وذلك تسهيلا عليهم وايضا تم اختيار الوقت بين الدفعتين المالية بشكل مدروس من قبل الفريق الخاص بالدفعات المالية في شركة ارامكو لتناسب امكانيات الطلاب
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الأول
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          بعد توقيع هذا العقد يتم إصدار فاتورة من معهد اللغة بألمانيا بقيمة اجمالية تبلغ 4500 يورو والتي يتوجب على الطالب تحويلها مباشرة إلى معهد اللغة (German Akademie ) .
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثاني
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          يتوجب على الطالب تحويل مبلغ 2000 يورو الى حساب شركة أرامكو في المانيا عند تحضير الملف الخاص بالسفارة الالمانية 
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'engineers'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          مميزات شركة ارامكو بما يتعلق بالدفعات المالية
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          تم تقسيم الدفعات المالية بما يتناسب مع الطلاب الجامعيين وذلك تسهيلا عليهم وايضا تم اختيار الوقت بين الدفعتين المالية بشكل مدروس من قبل الفريق الخاص بالدفعات المالية في شركة ارامكو لتناسب امكانيات المهندسين
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الأول
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          بعد توقيع هذا العقد يتوجب على المهندس تحويل مبلغ 3000 يورو مباشرة إلى معهد اللغة الالماني ( German Akademie) في المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثاني
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          عند الحصول على عقد العمل  يتوجب على المهندس تحويل القسط الثاني من خدمات ارامكو والبالغ  1500 وذلك على حساب شركة ارامكو في المانيا وذلك خلال فترة اسبوع من حصوله على العقد
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثالث
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          عند تحضير ملف السفارة وتسليمه كاملا للطرف الثاني بجميع الوثائق والأوراق الرسمية التي يحتاجها المهندس من عقد العمل و موافقة وزارة العمل وإجراءات التسريع ولم الشمل العائلي يقوم الطرف الثاني بدفع القسط الثالث من الخدمات والبالغ 1500 يورو على حساب شركة أرامكو في المانيا
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'doctors'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          مميزات شركة ارامكو بما يتعلق بالدفعات المالية
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          تم تقسيم الدفعات المالية بما يتناسب مع الطلاب الجامعيين وذلك تسهيلا عليهم وايضا تم اختيار الوقت بين الدفعتين المالية بشكل مدروس من قبل الفريق الخاص بالدفعات المالية في شركة ارامكو لتناسب امكانيات الطلاب
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الأول
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          بعد توقيع هذا العقد يتم تحويل القسط الاول والبالغ  3000 يورو الى حساب معهد اللغة (German Akademie )  في المانيا خلال مدة اسبوع من توقيع هذا العقد
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثاني
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          يتم دفع القسط الثاني والبالغ 1500 يورو على حساب شركة أرامكو في المانيا لتحضير ملف السفارة بجميع الأوراق والمستندات الرسمية وتسجيلات اللغة النهائية للملف اللازم للحصول على الفيزا من السفارة الألمانية ويشمل أيضا الخدمات المقدمة في المانيا عند وصول الطبيب
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          القسط الثالث
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          ﻋﻨﺪ ﺻﺪور ﻋﻘﺪ اﻻﺧﺘﺼﺎص  ﯾﺘﻢ دﻓﻊ اﻟﻘﺴﻂ اﻟﺜﺎﻟﺚ واﻟﺒﺎﻟﻎ 1000 يورو
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
      <iframe width="100%" height="315" src="https://www.youtube.com/embed/cHZcKGnnNGc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:['loading', 'arabic', 'view', 'lead', 'confirmed'],
  data(){
    return {
    }
  },
  methods:{
    
  },
  computed:{
    
  }
}
</script>

<style>

</style>